import React, { useContext, useEffect, useState } from 'react'
import GlobalContext from '../GlobalContext'
import TextContext from '../TextContext'
import ServiceContext from '../ServiceContext'
import GoodCheck from '../components/GoodCheck'
import '../css/openingSettings.css'
import { FormControl, InputGroup } from 'react-bootstrap'
import { RiAddFill, RiDeleteBin6Line } from 'react-icons/ri'
import { useImmer } from 'use-immer'
import GoodTime from '../components/GoodTime'

const OpeningSettings = ({selectedShop, submitOpeningsSignal, setSubmitOpeningsSignal}) => {

  const globalContext = useContext(GlobalContext)
  const serviceContext = useContext(ServiceContext)
  const textContext = useContext(TextContext)
  const [weekDays, setWeekDays]=useState([
    textContext.get(['sidebar', 'settings','shop', 'hour'], ['lunedi'], textContext.value),
    textContext.get(['sidebar', 'settings','shop', 'hour'], ['martedi'], textContext.value),
    textContext.get(['sidebar', 'settings','shop', 'hour'], ['mercoledi'], textContext.value),
    textContext.get(['sidebar','settings', 'shop', 'hour'], ['giovedi'], textContext.value),
    textContext.get(['sidebar', 'settings','shop', 'hour'], ['venerdi'], textContext.value),
    textContext.get(['sidebar', 'settings','shop', 'hour'], ['sabato'], textContext.value),
    textContext.get(['sidebar', 'settings','shop', 'hour'], ['domenica'], textContext.value),
  ])
  const [preparedOpenings, setPreparedOpenings] = useImmer({
    0: {
      closed: true,
      openings: [
        { start: '08:00', end: '18:00' }
      ]
    },
    1: {
      closed: true,
      openings: [
        { start: '08:00', end: '18:00' }
      ]
    },
    2: {
      closed: true,
      openings: [
        { start: '08:00', end: '18:00' }
      ]
    },
    3: {
      closed: true,
      openings: [
        { start: '08:00', end: '18:00' }
      ]
    },
    4: {
      closed: true,
      openings: [
        { start: '08:00', end: '18:00' }
      ]
    },
    5: {
      closed: true,
      openings: [
        { start: '08:00', end: '18:00' }
      ]
    },
    6: {
      closed: true,
      openings: [
        { start: '08:00', end: '18:00' }
      ]
    },
  })

  const prepareOpenings=(openings)=>{
    // console.log(openings)
    const shopOpenings=openings.filter(ope=>ope.Shop_ID==selectedShop)
    const edited=[]
    shopOpenings.forEach(ope => {
      if(edited.includes(ope.ope_day)){
        setPreparedOpenings(draft=>{draft[ope.ope_day].openings.push({
          ID: ope.ID, 
          start: ope.ope_start_hour,
          end: ope.ope_end_hour,
          edited: false,
          removed: false
        })})
      } else {
        setPreparedOpenings(draft=>{
          draft[ope.ope_day].openings=[{
            ID: ope.ID, 
            start: ope.ope_start_hour,
            end: ope.ope_end_hour,
            edited: false,
            removed: false
          }];
          draft[ope.ope_day].closed=false
        })
        edited.push(ope.ope_day)
      }
    });
    weekDays.forEach((day,i)=>{
      if(!edited.includes(i)){
        setPreparedOpenings(draft=>{
          draft[i]={
            closed: true,
            openings: [
              { start: '08:00', end: '18:00' }
            ]
        }
        })
      }
    })
  }
  const submitOpenings=async()=>{
    const postOpenigs=[]
    const pushOpenings=[]
    const removeOpenings=[]

    Object.keys(preparedOpenings).forEach(index=>{
      if(preparedOpenings[index].closed){
        //giorno chiuso
        preparedOpenings[index].openings.forEach(ope=>{
          if(ope.ID){
            //Apretura da eliminare
            removeOpenings.push(ope)
          }
        })
      } else {
        //giorno aperto
        preparedOpenings[index].openings.forEach(ope=>{
          if(ope.ID){
            //apertura pre esistente
            if(ope.removed){
              //apertura da rimuovere
              removeOpenings.push(ope)
            } else if (ope.edited){
              //apertura da modificare
              pushOpenings.push(ope)
            }
          } else {
            //apertura da aggiungere
            postOpenigs.push({...ope, day: index})
          }
        })
      }
    })

    const responses=[]
    
    serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
    postOpenigs.forEach(ope=>{
      const body={
        ope_day: ope.day,
        ope_start_hour: ope.start,
        ope_end_hour: ope.end,
        Shop_ID: selectedShop,
      }
      responses.push(
        fetch(`${globalContext.get.backendUrl}/papiv1/openings`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })
      )
    })

    pushOpenings.forEach(ope=>{
      const body={
        ID: ope.ID,
        ope_start_hour: ope.start,
        ope_end_hour: ope.end,
      }
      responses.push(
        fetch(`${globalContext.get.backendUrl}/papiv1/openings`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })
      )
    })

    removeOpenings.forEach(ope=>{
      const body={
        ID: ope.ID,
      }
      responses.push(
        fetch(`${globalContext.get.backendUrl}/papiv1/openings`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })
      )
    })
    if(responses.length>0){
      Promise.all(responses).then(()=>{
        console.log('reload')
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
        globalContext.set(draft=> {draft.Reloads.agency=true})
        serviceContext.set(draft=>{draft.Alerts.push({
          ID: Math.random(),
          message: textContext.get(['calendar', 'notify'], ['open_success'], textContext.value),
          ttl: 2000
      })})
      })
    } else {
      serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
    }
  }

  

  useEffect(()=>{
    if(globalContext.get){
        prepareOpenings(globalContext.get.openings)
    }
  },[globalContext.get])
  useEffect(()=>{
    if(globalContext.get){
      prepareOpenings(globalContext.get.openings)
    }
  },[selectedShop])
  useEffect(()=>{
    if(submitOpeningsSignal){
      setSubmitOpeningsSignal(false)
      submitOpenings()
    }
  },[submitOpeningsSignal])

  return (
    <>
      <hr />
      <p className='nac-title'>{textContext.get(['sidebar', 'settings','shop', 'hour'], ['title'], textContext.value)}</p>
      <ul style={{ listStyle: 'none' }} >
        {weekDays.map((day, index)=>(
          <li key={index} >
            <div className='ope-settings-header'>
              <p className='ope-settings-day-title'>{day}</p>
              <div className='ope-settings-check-column'>
                <GoodCheck
                  defaultChecked={preparedOpenings[index].closed}
                  onChange={(e) => setPreparedOpenings(draft => { draft[index].closed = e.target.value })}
                  label={textContext.get(['sidebar', 'settings','shop', 'hour'], ['close_day'], textContext.value)}
                  custom_styles={{
                    check: {
                      width: '20%',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-end'
                  },
                  }}
                />
              </div>
            </div>
            {!preparedOpenings[index].closed ? (
              <>
                <div className='ope-settings-hours'>
                  <div className='ope-settings-hours-column'>
                    <InputGroup className='ope-settings-hours-input'>
                      <InputGroup.Text>{textContext.get(['sidebar','settings', 'shop', 'hour'], ['open'], textContext.value)}</InputGroup.Text>
                      <GoodTime
                        value={preparedOpenings[index].openings[0].start}
                        max={preparedOpenings[index].openings[0].end}
                        onChange={(e) => setPreparedOpenings(draft => { 
                          draft[index].openings[0].start = e.target.value; 
                          draft[index].openings[0].ID?draft[index].openings[0].edited=true:draft[index].openings[0].edited=null
                        })}
                      />
                    </InputGroup>
                    <InputGroup className='ope-settings-hours-input'>
                      <InputGroup.Text>{textContext.get(['sidebar','settings', 'shop', 'hour'], ['close'], textContext.value)}</InputGroup.Text>
                      <GoodTime
                        value={preparedOpenings[index].openings[0].end}
                        min={preparedOpenings[index].openings[0].start}
                        onChange={(e) => setPreparedOpenings(draft => { 
                          draft[index].openings[0].end = e.target.value; 
                          draft[index].openings[0].ID?draft[index].openings[0].edited=true:draft[index].openings[0].edited=null
                        })}
                      />
                    </InputGroup>
                  </div>
                  <div className='ope-settings-hours-action-icon' >
                    <RiAddFill
                      size={'24pt'}
                      cursor='pointer'
                      onClick={() => { setPreparedOpenings(draft => { draft[index].openings.push({ start: '08:00', end: '18:00' }) }) }}
                    />
                  </div>
                </div>
                {preparedOpenings[index].openings.length > 1 ? (
                  <>
                    {preparedOpenings[index].openings.map((ope, i) => {
                      if (i !== 0 && ope.removed!=true) {
                        return (
                          <div key={i} className='ope-settings-hours'>
                            <div className='ope-settings-hours-column'>
                              <InputGroup className='ope-settings-hours-input'>
                                <InputGroup.Text>{textContext.get(['sidebar','settings', 'shop', 'hour'], ['open'], textContext.value)}</InputGroup.Text>
                                <GoodTime
                                  value={preparedOpenings[index].openings[i].start}
                                  max={preparedOpenings[index].openings[i].end}
                                  onChange={(e) => setPreparedOpenings(draft => { 
                                    draft[index].openings[i].start = e.target.value; 
                                    draft[index].openings[i].ID?draft[index].openings[i].edited=true:draft[index].openings[i].edited=null 
                                  })}
                                />
                              </InputGroup>
                              <InputGroup className='ope-settings-hours-input'>
                                <InputGroup.Text>{textContext.get(['sidebar','settings', 'shop', 'hour'], ['close'], textContext.value)}</InputGroup.Text>
                                <GoodTime
                                  value={preparedOpenings[index].openings[i].end}
                                  min={preparedOpenings[index].openings[i].start}
                                  onChange={(e) => setPreparedOpenings(draft => { 
                                    draft[index].openings[i].end = e.target.value; 
                                    draft[index].openings[i].ID?draft[index].openings[i].edited=true:draft[index].openings[i].edited=null
                                   })}
                                />
                              </InputGroup>
                            </div>
                            <div className='ope-settings-hours-action-icon' >
                              <RiDeleteBin6Line 
                                size={'24pt'}  
                                cursor='pointer'
                                onClick={()=>setPreparedOpenings(draft=>{
                                  draft[index].openings[i].ID?
                                  draft[index].openings[i].removed=true:
                                  draft[index].openings=draft[index].openings.filter((v,ind)=>ind!==i)
                                })}
                              />
                            </div>
                          </div>
                        )
                      }
                    })}
                  </>
                ) : (<></>)}
              </>
            ) : (<></>)}
          </li>
        ))}
      </ul>
    </>
  )
}

export default OpeningSettings